module.exports = __webpack_public_path__ + "static/media/GUIDE_0013_02.cfab4589.webp";